module.exports = __webpack_public_path__ + "static/media/virisol_3.f4723f24.png";